import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LogService from "../../../Services/LogService/LogService"
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';

const ViewAuditLogs = () => {
  const { id } = useParams();
  const navigate = useNavigate()

  const [auditData, setAuditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.token
  );

  const getAuditLog = async () => {
    try {
      const response = await LogService.getAuditLogsById({ id }, token);
      const log = response?.data?.body?.data;

      setAuditData({
        action: log?.action,
        entityType: log?.entity_type,
        entityId: log?.entity_id,
        performedBy: `${log?.first_name || ""} ${log?.last_name || ""}`,
        source: log?.source,
        timestamp: log?.timestamp,
        oldValues: log?.old_values,
        newValues: log?.new_values,
        actionMetadata: log?.metadata,
      });

      setLoading(false);
    } catch (error) {
      await HandleApiError(error);
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (id) {
      getAuditLog();
    }
  }, [id]);

  if (loading) {
    return <div className="main-inner-block">Loading...</div>;
  }

  return (
    <>
      <div className="main-inner-block">
        <div className='heading-content mt-3 mb-3'>
          <button
            className='green-btn back-button'
            onClick={handleBack}
          >
            <i className="fas fa-arrow-left" style={{ marginRight: '1px' }}></i>
            Back
          </button>
        </div>
        <div className="heading-content">Audit Log Details</div>
        <div className="content">
          <div className="white-box">
            <div className="d-flex gap-3 create-user-block w-100 justify-content-between">
              <div className="row m-0 w-100">
                <div className="mb-3 col-lg-3 ps-0 padding-right">
                  <label className="form-label">Action</label>
                  <div className="form-input-block">{auditData?.action || "-"}</div>
                </div>
                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Performed By</label>
                  <div className="form-input-block">{auditData?.performedBy || "-"}</div>
                </div>
                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Entity Type</label>
                  <div className="form-input-block">{auditData?.entityType || "-"}</div>
                </div>
                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Source</label>
                  <div className="form-input-block">{auditData?.source || "-"}</div>
                </div>
                <div className="mb-3 col-lg-3 padding-left">
                  <label className="form-label">Entity ID</label>
                  <div className="form-input-block">{auditData?.entityId || "-"}</div>
                </div>
                <div className="mb-3 col-lg-3 ps-0 padding-right">
                  <label className="form-label">Timestamp</label>
                  <div className="form-input-block">
                    {auditData?.timestamp ? new Date(auditData.timestamp).toLocaleString() : "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {auditData?.actionMetadata && (
        <div className="main-inner-block">
          <div className="heading-content">Change Details</div>
          <div className="content">
            <div className="white-box" style={{ whiteSpace: 'pre-wrap' }}>
              <code>{JSON.stringify(auditData?.actionMetadata, null, 2)}</code>
            </div>
          </div>
        </div>
      )}

      <div className="main-inner-block">
        <div className="heading-content">Previous Values</div>
        <div className="content">
          <div className="white-box" style={{ whiteSpace: 'pre-wrap' }}>
            <code>{JSON.stringify(auditData?.oldValues, null, 2)}</code>
          </div>
        </div>
      </div>

      <div className="main-inner-block">
        <div className="heading-content">New Values</div>
        <div className="content">
          <div className="white-box" style={{ whiteSpace: 'pre-wrap' }}>
            <code>{JSON.stringify(auditData?.newValues, null, 2)}</code>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewAuditLogs;
